import {
	FormControl,
	FormHelperText,
	InputLabel,
	MenuItem,
	Select,
} from "@material-ui/core";
import { ChangeEvent, CSSProperties, ReactNode } from "react";

export interface RxSelectBoxItemObject {
	label: string | number;
	value: string | number;
}
export const RxSelectBoxItemObjectInitialize: RxSelectBoxItemObject = {
	label: "",
	value: "",
};

interface RxSelectBoxProps {
	fullwidth?: boolean;
	id?: string;
	name?: string;
	label?: string;
	placeholder?: string;
	value?: string;
	required?: boolean;
	style?: CSSProperties;
	variant?: "standard" | "filled" | "outlined";
	size?: "small" | "medium";
	onBlur?: any;
	onChange?: (
		event: ChangeEvent<{
			name?: string;
			value: unknown;
		}>,
		child: ReactNode
	) => void;
	items?: RxSelectBoxItemObject[];
	defaultItem?: string | number;
	className?: string;
	helperText?: string | false;
	error?: boolean;
}

const RxSelectBox = (props: RxSelectBoxProps) => {
	return (
		<FormControl
			variant={props.variant}
			fullWidth={props.fullwidth}
			size={props.size}
			required={props.required}
			error={props.error}
		>
			<InputLabel id={"label-" + props.id}>{props.label}</InputLabel>
			<Select
				id={props.id}
				name={props.name}
				placeholder={props.placeholder}
				value={props.value}
				onChange={props.onChange}
				onBlur={props.onBlur}
				label={props.label}
				style={props.style}
				defaultValue={props.defaultItem}
				className={props.className}
			>
				{props.items?.map((item) => {
					return (
						<MenuItem key={item.label} value={item.value}>
							{item.label}
						</MenuItem>
					);
				})}
			</Select>
			<FormHelperText error={props.error}>{props.helperText}</FormHelperText>
		</FormControl>
	);
};
export default RxSelectBox;
